import React, { Component } from "react";
import { connect } from "react-redux";
import { logout } from "../actions/userAction";
import { chatunreadcount} from "../actions/dashboardAction";
import { Layout, Icon } from "antd";
import { Link } from "react-router-dom";
import addNotification from 'react-push-notification';
import UIfx from 'uifx'; 
//import beep from 'https://storage.googleapis.com/shopezy-a4bc4.appspot.com/Audio/bell.mp3';
const { Header } = Layout;
const tick = new UIfx("https://storage.googleapis.com/shopezy-a4bc4.appspot.com/Audio/bell.mp3");


class TopHeader extends Component {
  constructor(props) {
    super(props);
    // state
    this.state = {
      current: "1",
      volume:0,
    };
  }
  componentWillMount() {
    this.props.chatunreadcount().then(res=>{
      console.log(res)
      //this.setState({count: res});
    })
    setTimeout(() => {
      this.setState({volume: 1});
    }, 7000)
  }
  componentDidUpdate(prevProps) 
  {
    if (prevProps.chatlive !== this.props.chatlive) {
      console.log("Did Update");
      if(parseInt(this.props.chatlive) !== 0)
      {
        //console.log("will receive");
        tick.setVolume(this.state.volume).play();
        if(this.state.volume === 1)
        {
         
          console.log("Chat receive");
          addNotification({
            title: 'Shopezy',
            subtitle: 'This is a subtitle',
            message: 'New message received..!',
            theme: 'darkblue',
            native: true // when using native, your OS will handle theming.
        });
        }
       
      }
    }

  }
  // componentWillReceiveProps(nextProps)
  // {
  //   if(this.props.chatlive !== nextProps.chatlive ) 
  //   {

  //     if(parseInt(this.props.chatlive) !== 0)
  //     {
  //       console.log("will receive");
  //       tick.setVolume(this.state.volume).play();
  //       if(this.state.volume === 1)
  //       {
         
  //         console.log("Chat receive");
  //         addNotification({
  //           title: 'Shopezy',
  //           subtitle: 'This is a subtitle',
  //           message: 'New message received..!',
  //           theme: 'darkblue',
  //           native: true // when using native, your OS will handle theming.
  //       });
  //       }
       
  //     }
  //   }
    
  // } 

  render() {
    return (
      <Header className="text-right">
        {/* <span className="badge">{this.state.count}</span>
        <Button style={{marginRight:20}} type="primary" shape="circle" icon="wechat"></Button> */}
        <Link to="/logout" onClick={() => this.props.logout()}>
          <Icon type="logout" />
          <span className="nav-text"> Logout</span>
        </Link>
      </Header>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return { user: state.user,chatlive:state.chatlive };
}

export default connect(mapStateToProps,{ logout,chatunreadcount })(TopHeader);
